import React, { useContext } from 'react';
import { ImageViewer } from '../viewer/image-viewer.js';
import { Node_Type } from 'ricos-schema';
import { Loader, MediaItemErrorMsg } from 'wix-rich-content-ui-components';
import { RicosContext } from 'ricos-context';
import 'classnames';
import '../types.js';
import 'lodash';
import 'wix-rich-content-common';
import '@wix/image';
import '../consts.js';
import '../icons/expand.js';
import '../InPluginInput.js';
import '../style-inject.es-746bb8ed.js';
import '../image-viewer.rtlignore-4c2a6716.js';

const Image = ({ settings, updateAttributes, node }) => {
  const { theme, t, isMobile, experiments } = useContext(RicosContext);
  const helpers = {};
  const setComponentUrl = () => null;
  const { loading, loadingPercentage, error, tempData } = node.attrs;
  const handleCaptionChange = (caption) => {
    updateAttributes({ caption });
  };
  const { src } = node.attrs.image || {};
  const shouldRender = !!tempData || (src == null ? void 0 : src.url) || (src == null ? void 0 : src.id);
  const ricosNode = {
    imageData: node.attrs,
    id: node.attrs.id,
    type: Node_Type.IMAGE,
    nodes: []
  };
  return shouldRender ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ImageViewer,
    {
      isMobile,
      helpers,
      node: ricosNode,
      isLoading: loading,
      dataUrl: tempData,
      settings,
      defaultCaption: t("ImageViewer_Caption"),
      onCaptionChange: handleCaptionChange,
      setFocusToBlock: () => {
      },
      setComponentUrl,
      experiments
    }
  ), loading && /* @__PURE__ */ React.createElement(Loader, { theme, type: "medium", percent: loadingPercentage }), error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error, t })) : null;
};

export { Image };
//# sourceMappingURL=component.js.map
